'use strict';
const jwtModule =  require('angular-jwt');
const localForageModule = require('angular-localforage');
const ngIdleModule = require('ng-idle');
const uiRouter = require('angular-ui-router');
import {getInjectableName} from 'ng-metadata/core';
import {getSessionTimeoutParams} from '../appConfig/appConfigForward';
import {ModelService} from '../infra/dataStructures/model/model.service';
import {getUrlContext, getVid} from '../appConfig/appConfigForward';
var angular:angular.IAngularStatic =  require('angular');
import appConfigModule from '../appConfig/appConfig.module';
import {bootstrapJwt, UserSessionManagerService} from "./userSessionManager.service";

export default  angular.module('primo-explore.security', [jwtModule, appConfigModule.name, localForageModule, ngIdleModule, uiRouter])
    .config(Config)
    .run(Run);





function Config(IdleProvider, jwtInterceptorProvider, $httpProvider) {
    IdleProvider.interrupt('keydown mousedown');
    jwtInterceptorProvider.tokenGetter = getJwtToken;
    $httpProvider.interceptors.push(skipJwt);
    $httpProvider.interceptors.push('jwtInterceptor'); // --> Sending jwt in each request
    $httpProvider.interceptors.push(prmInterceptor);
    $httpProvider.interceptors.push(responseErrorInterceptor);
    $httpProvider.interceptors.push(addToRequestInterceptor);
    //$httpProvider.interceptors.push(aPIInterceptorProvider);

    function skipJwt(){
        return {
            request: (request)=> {
                if(!(request.url.includes('primo_library/libweb') || request.url.includes('/primaws/rest') || request.url.includes('/primaws/suprimaLogout'))) {
                    request.skipAuthorization = true;
                }
                return request;
            }
        };
    }

    function prmInterceptor(modelService){

        var service = {

            response: function (response){

                if(modelService.active) {
                    let model = modelService.modelInstance;
                    if (response.config.url.indexOf('/rest/') > -1) {
                        let key = modelService.getKey(response.config.url);
                        modelService.addToModel(key, response);
                    }
                }

                return response;
            }
        };

        return service;
    }

    prmInterceptor.$inject = [getInjectableName(ModelService)];


    function responseErrorInterceptor($injector, $q: ng.IQService) {
        return {
            responseError: function (response) {
                switch (response.status) {
                    case 401:
                        if (response.headers('invalid_jwt') != null) { //if response came from WsXsIpFilter.java then perform logout
                            let userSessionManager: UserSessionManagerService = $injector.get(getInjectableName(UserSessionManagerService));
                            userSessionManager.logout(true);
                        }
                }
                return $q.reject(response);
            }
        }
    }

    responseErrorInterceptor.$inject = ['$injector', '$q'];


    function addToRequestInterceptor(i18nService) {
        var service = {

            request: function (request){
                if(request.url.includes('primaws/') || request.url.includes('primo_library/libweb')) {
                    if (request.url.includes('primaws/') && !request.params) {
                        request.params = {}; //so every request in PrimoVE gets lang param
                    }
                    if (request.params && !request.params.lang && i18nService.getLanguage()) {
                        request.params.lang = i18nService.getLanguage();
                    }

                }

                return request;
            }
        };

        return service;
    }

    addToRequestInterceptor.$inject = ['I18nService'];

}
Config.$inject = ['IdleProvider', 'jwtInterceptorProvider', '$httpProvider'];




function getJwtToken(userSessionManagerService) {
    let jwt =  userSessionManagerService.getJwt();
    if (jwt) {
        return jwt;
    }

    return bootstrapJwt();
}

getJwtToken.$inject = [getInjectableName(UserSessionManagerService)];



function Run(userSessionManagerService, $http, $location) {
    if($location.absUrl().indexOf('debugmode=true') > -1){
        $http.defaults.headers.common['explore-debug-mode'] = '1';
    }
    userSessionManagerService.runStartupCode();
}

Run.$inject = [ getInjectableName(UserSessionManagerService), '$http', '$location'];
import './sessionTimeout.service';





// WEBPACK FOOTER //
// ./src/main/webapp/components/security/security.module.ts